<div class="bg-white px-4">
  <p>Have a procedure code from your doctor?</p>
  <div class="position-relative mt-2">
    <rs-search-field
      label="Enter procedure code or description"
      id="procedureSearch"
      name="value"
      (search)="onSearch($event)"
      autofocus="true">
    </rs-search-field>
  </div>
  <div *ngIf="searchMode" class="search-helper-text pb-3">
    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
      <span>Selected services stay in the Selected Services panel above.</span>
      <button
        type="button"
        class="rs-btn-link fw-700"
        (click)="backToCategories()">
        Back to categories
      </button>
    </div>
  </div>
</div>

<div class="procedures-list bg-white p-4" *ngIf="searchMode">
  <div class="card p-0" *ngIf="procedures && procedures.length > 0">
    <div class="fw-700 fs-18 mb-3">{{ procedures.length }} Results</div>

    <div
      *ngFor="let group of procedures"
      class="bottom-border pt-4 pb-2">
      <div class="selected-item d-flex justify-content-between align-items-center">
        <div class="selected-item-title align-items-top">
          <rs-checkbox
            [id]="'search-procedure-' + group.id"
            [label]="group.name | translate"
            [ngModel]="group.selected"
            (change)="toggleProcedure($event, group)">
          </rs-checkbox>
        <button
          *ngIf="group.procedures.length > 1"
          (click)="group.open = !group.open"
          (clickOutside)="group.open = false"
          class="rs-btn-link d-flex align-items-center fw-700 stack">
          {{ group.procedures.length }}
          {{ group.procedures.length === 1 ? 'procedure' : 'procedures' }}
        </button>
        </div>
      </div>
      <div *ngIf="group.open" class="pulldown-menu p-3">
        <div class="fw-700 fs-18 mb-3">Procedures in this group</div>
        <div *ngFor="let procedure of group.procedures">
          {{ procedure.name | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="searchMode && procedures && procedures.length == 0"
  class="card p-3">
  <div class="fw-700 fs-18 mb-3">
    <span class="color-primary">0</span>
    Results
  </div>
  <div class="selected-item fs-18 py-3">
    <ng-container
      *ngIf="procedureSearchConfig?.['procedure-search-no-result'].title; else noTitleBlock">
      <div class="fw-700">
        {{
          procedureSearchConfig['procedure-search-no-result'].title
            | translate
        }}
      </div>
    </ng-container>
    <ng-template #noTitleBlock>
      <div class="fw-700">
        If you're having trouble finding a procedure to be estimated…
      </div>
    </ng-template>

    <ng-container
      *ngIf="procedureSearchConfig?.['procedure-search-no-result']?.description; else noDescriptionBlock">
      <div>
        {{
          procedureSearchConfig['procedure-search-no-result']
            .description | translate
        }}
        <a
          class="rs-btn-link fw-700"
          href="{{ procedureSearchConfig?.['procedure-search-no-result']?.link | translate }}"
          >{{ procedureSearchConfig?.['procedure-search-no-result']?.linkDisplay | translate }}</a
        >
      </div>
    </ng-container>

    <ng-template #noDescriptionBlock>
      <div>
        Only procedures that are approved to be estimated can be searched and
        selected. Try to broaden your search to include more results, or
        <b class="rs-btn-link" (click)="showContactMeModal()">
          contact a representative
        </b>
        about your search results.
      </div>
    </ng-template>
  </div>
</div>
<div
  *ngIf="searchMode && procedures && procedures.length !== 0"
  class="card p-3">
  <div class="selected-item fs-18 py-3">
    <ng-container
      *ngIf="procedureSearchConfig?.['procedure-search-result']?.title; else noTitleBlock">
      <div class="fw-700">
        {{
          procedureSearchConfig['procedure-search-result'].title
            | translate
        }}
      </div>
    </ng-container>
    <ng-template #noTitleBlock>
      <div class="fw-700">Still not seeing what you are looking for?</div>
    </ng-template>

    <ng-container
      *ngIf="procedureSearchConfig?.['procedure-search-result']?.description; else noDescriptionBlock">
      <div>
        {{
          procedureSearchConfig['procedure-search-result'].description
            | translate
        }}
        <a
          class="rs-btn-link fw-700"
          href="{{ procedureSearchConfig?.['procedure-search-result']?.link | translate }}"
          >{{ procedureSearchConfig?.['procedure-search-result']?.linkDisplay | translate }}</a
        >
      </div>
    </ng-container>

    <ng-template #noDescriptionBlock>
      <div>
        Have a
        <b class="rs-btn-link" (click)="showContactMeModal()">
          Patient Representative
        </b>
        contact me.
      </div>
    </ng-template>
  </div>
</div>
